import { render, staticRenderFns } from "./crmBranchsEdit.vue?vue&type=template&id=48caa570&scoped=true"
import script from "./crmBranchsEdit.vue?vue&type=script&lang=js"
export * from "./crmBranchsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caa570",
  null
  
)

export default component.exports